// TotalInventory Getters

export const getTotalInventoryList = state => {
  return state.totalInventoryList
}

export const getTotalInventoryInfo = state => {
  return state.totalInventoryInfo
}

export const getInventoryInfo = state => {
  return state.inventoryInfo
}
